import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { Tables } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<Tables<"files">>();

/**
 * One row per sheet the run has printed, newest first — the order the files endpoint returns them
 * in, and the one that matters: the newest sheet is the one whose plates are current.
 */
export const returnOrderSheetsTableColumns = [
	columnHelper.accessor("fileName", {
		id: "fileName",
		header: localized("general.name"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("createdAt", {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => moment(cell.getValue()).shortFormat(),
	}),
	createRowActions(RowActions),
];
